module.exports = __webpack_public_path__ + "static/img/login-4.5c7c6c4.jpg";